import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/auth/')) return next(req);

  const storageService = inject(StorageService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const authToken = storageService.getToken().token;
  if (!authToken) return next(req);

  const authorize = (token: string) => req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  return next(authorize(authToken)).pipe(
    catchError(error => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401 || !storageService.getRefreshToken()) {
        return throwError(() => error);
      }

      return authService.refreshSession().pipe(
        switchMap(() => {
          const refreshedToken = storageService.getToken().token;
          return refreshedToken ? next(authorize(refreshedToken)) : throwError(() => error);
        }),
        catchError(refreshError => {
          authService.clearSession();
          router.navigate(['/login'], { replaceUrl: true });
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};
